/**
* In this file contains the Vaccination UI screen and logic
**/
import { useSelector } from 'react-redux';
import { printVaccinationDose } from './../../services/UtilsService';
import { useTranslation } from 'react-i18next';

//Shared Vaccination Table View
const Vaccination = ({dob,data,bodyWidth}) => {
	
	/**
	 * Intial state declaration
	 **/
  const masterVaccination=useSelector(state => state?.vaccination);
  console.log("masterVaccination", masterVaccination);
  const role = Number(localStorage.getItem('role'));
  const currentLang = localStorage.getItem('i18nextLng');
  const { t } = useTranslation();

  //Bind the age value
  const getLocalizedAge = (age) => {
    if (currentLang === 'ta') {
      return age.name_tamil || age.name; // fallback if tamil not present
    }
    return age.name;
  };

    const getLocalizedName = (name) => {
		if (currentLang === 'ta') {
		return name.name_tamil || name.name; // fallback if tamil not present
		}
		return name.name;
	};

	const getLocalizedShortName = (name) => {
		if (currentLang === 'ta') {
		return name.short_name_tamil || name.short_name; // fallback if tamil not present
		}
		return name.short_name;
	};

	const getLocalizedVaccinationTypeName = (typeId) => {
		const typeObj = masterVaccination?.vaccinationType?.find(item => item.id === typeId);
		if (!typeObj) return '';
		return currentLang === 'ta' ? (typeObj.name_tamil || typeObj.name) : typeObj.name;
	};

  return (
   <div className="row">
	  <div className="col-xxl-12 mb-2">
		<div className={`table-responsive ${role === 4 ? 'admin-table-responsive' : ''}`}>
		{/*Vaccination Table */}
		  <table className={`table table-bordered vaccTable ${role===4 ? 'admin-vaccTable' : ''}`} style={{width:bodyWidth?bodyWidth:'100%'}}>
			<thead>
			  <tr>
				<th width={175} className="stickyColum">{t('modal.vaccinationDetails')}</th>
				{masterVaccination && masterVaccination.length !==0 && masterVaccination?.vaccinationAge.map(age=>(<th key={age.id}className="text-center">{getLocalizedAge(age)}</th>))}
			  </tr>
			</thead>
			<tbody>
			{/*Dynamic table data creating*/}
			{masterVaccination && masterVaccination.length !==0 && masterVaccination?.vaccinationName.map(name=>
			(<tr key={name.id}>
			  <td valign="middle" className="stickyColum">
				<b>{getLocalizedName(name)}</b>{getLocalizedShortName(name)}
			  </td>
			  {masterVaccination && masterVaccination.length !==0 && masterVaccination?.vaccinationAge.map(age=>(printVaccinationDose(name.id,age.id,masterVaccination?.mapping,dob,age.name,data,masterVaccination?.vaccinationType,t,getLocalizedVaccinationTypeName)))}
			</tr>))}
			</tbody>
		  </table>
		  {/*End Vaccination Table */}
		</div>
	  </div>
	</div>
  );
	
};

export default Vaccination;